export function validateInput(input: string): boolean {
  // return /^(-?\d*(\.\d+)?[,;\s]+)*-?\d*(\.\d+)?[,;\s]*$/.test(input)
  return /^[-\d\.,;\sNa]*$/.test(input)
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/services/utility-services/sanitise-validation.ts
 **/